"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M11.66 4.133a.5.5 0 0 1 .68 0l6.5 6a.5.5 0 0 1-.34.867H17v4h.5a.5.5 0 0 1 .5.5V17h.5a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5H6v-1.5a.5.5 0 0 1 .5-.5H7v-4H5.5a.5.5 0 0 1-.34-.867zM8 11v4h2v-4zm3 0v4h2v-4zm3 0v4h2v-4zm3 5H7v1h10zm1 2H6v1h12zM6.779 10H17.22L12 5.18z"
}), 'Bank');
//# sourceMappingURL=index.js.map